import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopDevPageSideVideoSidePrimis from './primis/DesktopDevPageSideVideoSide';
const DesktopDevPageSideVideoSide = ({ safety ='off'  })=>{
    const primisOff = useFlag('ads_primis_perf');
    if (primisOff) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(DesktopDevPageSideVideoSidePrimis, {
        safety: safety
    });
};
DesktopDevPageSideVideoSide.displayName = 'DesktopDevPageSideVideoSide';
export default DesktopDevPageSideVideoSide;
